var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23:3648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00391 16.5C13.146 16.5 16.5039 13.1421 16.5039 9C16.5039 4.85786 13.146 1.5 9.00391 1.5C4.86177 1.5 1.50391 4.85786 1.50391 9C1.50391 13.1421 4.86177 16.5 9.00391 16.5Z",
    stroke: "#3F3F46",
    strokeOpacity: 0.56,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82129 6.74994C6.99762 6.24869 7.34565 5.82602 7.80375 5.55679C8.26186 5.28756 8.80046 5.18914 9.32417 5.27897C9.84788 5.3688 10.3229 5.64108 10.6651 6.04758C11.0073 6.45409 11.1946 6.96858 11.1938 7.49994C11.1938 8.99994 8.94379 9.74994 8.94379 9.74994",
    stroke: "#3F3F46",
    strokeOpacity: 0.56,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00391 12.75H9.01141",
    stroke: "#3F3F46",
    strokeOpacity: 0.56,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23:3648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/Help-Circle.c9f3a6b271972106391f878033e6c8bd.svg";
export { ForwardRef as ReactComponent };